import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Grid } from '@mui/material'
import { Button } from '@material-ui/core'
import Rating from '@mui/material/Rating'
import Stack from '@mui/material/Stack'
import RoadSafetyTile from 'src/components/BuyPolicy/insuranceScreens/bike/RoadSafetyTile'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import PromiseHand from 'src/assets/Buy_Policy_Images/promiseHand.svg'
import CheckIcon from '@mui/icons-material/Check'
import SelectedStarLogo from 'src/assets/Buy_Policy_Images/starSelected.svg'
import CongratulationsConfettiModal from 'src/components/BuyPolicy/common/CongratulationsConfettiModal'
import { scrollToComponent } from 'src/utils/commonMethods'
import { ruleData } from 'src/utils/constants/BuyPolicyBike'
import { COMMITMENT_FOR_ROAD_SAFETY } from 'src/utils/constants/Bike'

const BikeRoadSafety = () => {
  const classes = useStyles()
  const [rating, setRating] = useState(0)
  const [showcCommitments, setShowcCommitments] = useState(false)
  const [commitmentsSelected, setCommitmentsSelected] = useState(false)
  const [openConfettiModal, setOpenConfettiModal] = useState(false)
  const [showClickHere, setShowClickHere] = useState(true)
  const [showStarFlag, setShowStarFlag] = useState(false)
  const [ruleSelected, setRuleSelected] = useState({})

  const handleIPledge = () => {
    setCommitmentsSelected((prevSate) => {
      if (!prevSate) {
        setRating((prevState) => prevState + 1)
      } else {
        setRating((prevState) => prevState - 1)
      }

      return !prevSate
    })
    setOpenConfettiModal(true)
  }

  const handleClickHere = () => {
    setShowClickHere(!showClickHere)
    setShowcCommitments(!showcCommitments)
  }
  const handleClose = () => {
    setShowStarFlag(true)
    setOpenConfettiModal(false)
    const roadSafetyElement = document.getElementById('roadSafety')

    if (roadSafetyElement) {
      const yPosition = roadSafetyElement?.offsetTop
      window.scrollTo({
        top: yPosition,
        behavior: 'smooth',
      })
    }
  }
  const setRatingObject = (newValue) => {
    const ratingObject = {
      1: newValue >= 1,
      2: newValue >= 2,
      3: newValue >= 3,
      4: newValue >= 4,
    }
    setRating(newValue)
    setRuleSelected(ratingObject)
  }

  useEffect(() => {
    if (showcCommitments) {
      scrollToComponent('iPledgeSection')
    }
  }, [showcCommitments])

  return (
    <Box>
      {openConfettiModal ? (
        <CongratulationsConfettiModal
          openConfettiModal={openConfettiModal}
          handleClose={handleClose}
          message={COMMITMENT_FOR_ROAD_SAFETY}
        />
      ) : null}
      <Box className={classes.bikeRoadSafetyContainer} id='roadSafety'>
        <Box className={classes.bikeRoadSafetyHeadingSection}>
          <Box>
            <Box className={classes.safteyHeading}>
              Bharat Road Safety Movement
            </Box>
            <Box className={classes.safteyTag}>A Trovity Intiative</Box>
          </Box>
          <Box>
            <Box className={classes.citizenQuestion}>
              Are you a responsible Citizen?
            </Box>
            <Box className={classes.bikeRoadSafetyRatingSection}>
              <Box className={classes.citizenTag}>Know your score</Box>
              <Box>
                <Stack spacing={1}>
                  <Rating
                    id='rating'
                    name='size-large'
                    value={rating}
                    className={classes.bikeRoadSafetyRatingStar}
                    onChange={(event, newValue) => {
                      setRatingObject(newValue)
                    }}
                  />
                </Stack>
              </Box>
            </Box>
          </Box>
        </Box>

        <div>
          <Box className={classes.ruleTileContainer}>
            {ruleData?.map((item) => {
              return (
                <Grid item xs={3} key={item?.id}>
                  <RoadSafetyTile
                    logo={item?.logo}
                    text={item?.text}
                    setRating={setRating}
                    ruleSelected={!!ruleSelected[item?.id]}
                    setRuleSelected={() =>
                      setRuleSelected((prev) => ({
                        ...prev,
                        [item?.id]: !prev[item?.id],
                      }))
                    }
                    ruleId={item?.id}
                    rating={rating}
                  />
                </Grid>
              )
            })}
          </Box>
        </div>

        {showClickHere ? (
          <Box className={classes.pledgeFlex}>
            <Box className={classes.pledgeContainer}>
              <Box className={classes.pledgeQuestionSection}>
                <Box className={classes.pledgeQuestionNormal}>
                  Are you ready to
                </Box>
                <Box className={classes.pledgeQuestionBold}>
                  Pledge My 12 Commitments
                </Box>
              </Box>
              <Box className={classes.pledgeAnswerSection}>
                <Box className={classes.pledgeAnswerSectionText}>If yes</Box>
                <Button
                  variant='contained'
                  className={classes.pledgeBtn}
                  onClick={handleClickHere}
                  id='clickHere'
                >
                  Click Here
                </Button>
              </Box>
            </Box>
          </Box>
        ) : null}

        {showcCommitments ? (
          <Box id='iPledgeSection'>
            {showStarFlag ? (
              <Box
                className={`${classes.starFlagContainer} ${classes.starFlagAnimation}`}
              >
                <Box className={classes.starFlagText}>
                  Your initiative contributes to a better society
                </Box>
                <Box className={classes.starFlagIconSection}>
                  <StarIcon className={classes.orangeStar} />
                  <StarIcon className={classes.orangeStar} />
                  <StarBorderIcon className={classes.blueStar} />
                  <StarIcon className={classes.greenStar} />
                  <StarIcon className={classes.greenStar} />
                </Box>
              </Box>
            ) : null}

            <Box className={classes.commitmentsSection}>
              {commitmentsSelected ? (
                <img
                  className={classes.selectedStar}
                  src={SelectedStarLogo}
                  height={'33px'}
                  width={'34.74px'}
                  alt='selected-star'
                />
              ) : null}
              <Box className={classes.pledgeQuestionSection}>
                <Box className={classes.pledgeQuestionNormal}>
                  Are you ready to
                </Box>
                <Box className={classes.pledgeQuestionBold}>
                  Pledge My 12 Commitments
                </Box>
              </Box>
              <Box>
                <Box className={classes.rowFlex}>
                  <Box className={classes.columnFlex}>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />I
                      will maintain insurance for my bike.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Helmet on, always.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Signal with indicators.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Respect traffic signals.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Stay in designated lanes.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      No wrong routes.
                    </Box>
                  </Box>
                  <Box className={classes.columnFlex}>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Never drive under the alcohol influence.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Park responsibly.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Honk only when needed.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Single rider, always.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Use high-beam judiciously.
                    </Box>
                    <Box>
                      <CheckIcon className={classes.commitmentCheckIcon} />
                      Lights in working order.
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box className={classes.iPledgeBtnContainer}>
                <Button
                  id='iPledgeButton'
                  variant='contained'
                  endIcon={<img src={PromiseHand} alt='promise-hand' />}
                  className={classes.iPledgeBtn}
                  onClick={handleIPledge}
                >
                  I Pledge
                </Button>
              </Box>
            </Box>
          </Box>
        ) : null}
      </Box>
    </Box>
  )
}

export default BikeRoadSafety

const useStyles = makeStyles({
  bikeRoadSafetyContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    backgroundSize: '100% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
    paddingTop: 30,
    paddingLeft: 90,
    paddingRight: 90,
    paddingBottom: 30,
    gap: 30,
  },
  bikeRoadSafetyHeadingSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  bikeRoadSafetyRatingSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 15,
  },
  bikeRoadSafetyRatingStar: {
    fontSize: '34px !important',
    color: '#4DC3E3 !important',
  },

  ruleTileContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
  safteyHeading: {
    fontFamily: 'Roboto',
    fontSize: '28px',
    fontWeight: 500,
    lineHeight: '39.81px',
    letterSpacing: '0em',
    color: '#000000',
  },
  safteyTag: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: 400,
    fontStyle: 'italic',
    lineHeight: '28.44px',
    letterSpacing: '0em',
    color: '#3797B1',
    display: 'flex',
    justifyContent: 'end',
  },
  citizenQuestion: {
    fontFamily: 'Roboto',
    fontSize: '22px',
    fontWeight: 500,
    lineHeight: '31.28px',
    letterSpacing: '0em',
    color: '#000000',
    display: 'flex',
    justifyContent: 'end',
  },
  citizenTag: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28.44px',
    letterSpacing: '0em',
    color: '#228BA8',
  },
  pledgeFlex: {
    display: 'flex',
    justifyContent: 'center',
  },
  pledgeContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 10,
    gap: 40,
    width: '554px',
    height: '156px',
    borderRadius: '20px',
    background:
      'linear-gradient(0deg, #EFEFEF 0%, rgba(255, 255, 255, 0) 100%)',
    boxShadow: '0px 0px 15px 0px #0000001A',
  },
  pledgeQuestionSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pledgeAnswerSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 7,
  },
  pledgeBtn: {
    width: '150px',
    height: '40px',
    borderRadius: '10px',
    background: '#4DC3E3',
    color: '#FFFFFF',
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '21.6px',
    letterSpacing: '0em',
  },
  pledgeQuestionBold: {
    color: '#2BBAE1',
    fontFamily: 'Roboto',
    fontSize: '26px',
    fontWeight: 500,
    lineHeight: '36.97px',
    letterSpacing: '0em',
  },
  pledgeQuestionNormal: {
    color: '#6F6F6F',
    fontFamily: 'Roboto',
    fontSize: '19px',
    fontWeight: 400,
    lineHeight: '27.02px',
    letterSpacing: '0em',
  },
  pledgeAnswerSectionText: {
    color: '#929292',
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '21.6px',
    letterSpacing: '0em',
  },
  starFlagContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginBottom: 20,
  },
  starFlagText: {
    display: 'flex',
    justifyContent: 'end',
    color: '#000000',
    fontFamily: 'Roboto',
    fontSize: '22px',
    fontWeight: 400,
    lineHeight: '31.28px',
    letterSpacing: '0em',
  },
  starFlagIconSection: {
    display: 'flex',
    justifyContent: 'end',
  },
  orangeStar: {
    width: '34.74px !important',
    height: '33px !important',
    color: '#FF9933',
  },
  greenStar: {
    width: '34.74px !important',
    height: '33px !important',
    color: '#128807',
  },
  blueStar: {
    width: '34.74px !important',
    height: '33px !important',
    color: '#000088',
  },
  commitmentsSection: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 30,
    background: '#FFFFFF',
    boxShadow: '0px 0px 15px 0px #00000033',
    padding: 20,
  },
  columnFlex: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    gap: 20,
  },
  rowFlex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 90,
  },
  commitmentCheckIcon: {
    color: '#44C0E1',
    fontSize: '20px !important',
  },
  iPledgeBtnContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  iPledgeBtn: {
    background: '#4DC3E3',
    borderRadius: '10px',
    color: '#FFFFFF',
  },
  selectedStar: {
    position: 'absolute',
    top: -10,
    right: -15,
  },
  starFlagAnimation: {
    opacity: 0,
    transform: 'translateY(20px)',
    animation: '$starFlagAnimation 1s ease-in-out forwards',
  },

  '@keyframes starFlagAnimation': {
    '0%': {
      opacity: 0,
      transform: 'translateY(50px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
})
